/**
 * テーブル関連の定数
 * 在庫管理テーブルで使用する仮想スクロール、レイアウト、識別子、グループメニューの定数を定義
 */

/**
 * テーブル仮想スクロール関連の定数
 */
export const VIRTUAL_SCROLL = {
  /** 各行のピクセル高さ */
  ITEM_HEIGHT: 20,
  /** 仮想スクロールのバッファサイズ（動的に調整される） */
  BUFFER_SIZE: 10,
  /** スクロール終了判定の遅延時間（ミリ秒） */
  SCROLL_END_DELAY: 150,
} as const;

/**
 * テーブルレイアウト関連の定数
 */
export const TABLE_LAYOUT = {
  /** テーブルの最小幅（ピクセル） */
  MIN_WIDTH: 1578,
  /** 列の最小幅（ピクセル） */
  MIN_COLUMN_WIDTH: 50,
  /** 列のデフォルト幅（ピクセル） */
  DEFAULT_COLUMN_WIDTH: 100,
  /** ヘッダー行の高さ（ピクセル） */
  HEADER_HEIGHT: 32,
  /** デフォルトヘッダー列数 */
  HEADER_COLUMN_DEFAULT_NUMBER: 54,
  /** 発注モードヘッダー列数 */
  ORDER_HEADER_COLUMN_DEFAULT_NUMBER: 70,
} as const;

/**
 * テーブル識別子関連の定数
 */
export const TABLE_IDS = {
  /** 在庫管理テーブルのDOM ID */
  INVENTORY_CONTROL: 'inventory-control-table',
  /** 発注モードテーブルのDOM ID */
  ORDER_MODE: 'order-mode-inventory-control-table',
} as const;

/**
 * グループメニュー関連の定数
 */
export const GROUP_MENU = {
  /** グループメニューアイテム */
  ITEMS: ['CreateGroup', 'AddBusinessToGroup', 'EditGroup', 'DeleteGroup'] as const,
  /** グループアクションタイプ */
  ACTION_TYPES: ['none', 'create', 'delete', 'updateName', 'addBusiness', 'deleteBusiness'] as const,
} as const;

/**
 * サマリー行関連定数
 */
export const SUMMARY_ROW_BLANK_HEADER_KEYS = [
  'alert',
  'desiredDeliveryDate',
  'createOrder',
  'previousMonthAccuracy',
  'settingAccuracy',
  'accuracyHistory',
  'supplierAnnounce',
] as const;

/** 発注前後の値を表示する対象のキー */
export const BEFORE_AFTER_KEYS = ['expectedEndInventory', 'turnOver'] as const;

/**
 * 取引編集関連定数
 */
export const BUSINESS_ROW_MENU_ITEMS = [
  { value: 'orderBasis', icon: 'find_in_page', text: '発注根拠表示', isMdi: true, isAggregateOnly: true, isAvailableInOrderMode: true },
  {
    value: 'create',
    icon: 'copy',
    text: 'コピー新規作成',
    isMdi: false,
    isAggregateOnly: false,
    isAvailableInOrderMode: true,
  },
  {
    value: 'edit',
    icon: 'editPen',
    text: 'マスターデータ編集',
    isMdi: false,
    isAggregateOnly: false,
    isAvailableInOrderMode: true,
  },
  {
    value: 'editTransaction',
    icon: 'editPen',
    text: '数値データ編集',
    isMdi: false,
    isAggregateOnly: false,
    isAvailableInOrderMode: false,
  },
  {
    value: 'delete',
    icon: 'trash-box',
    text: '削除',
    isMdi: false,
    isAggregateOnly: false,
    isAvailableInOrderMode: true,
  },
] as const;

/**
 * 在庫管理ページ管理メニュー関連定数
 */
export const INVENTORY_CONTROL_MENU_ITEMS = [
  {
    value: 'excelExport',
    icon: 'save_alt',
    text: 'Excel出力',
  },
  {
    value: 'editDisplayRange',
    icon: 'view_column',
    text: '表示範囲設定',
  },
  { value: 'combinedOrderSetting', icon: 'settings', text: 'まとめ発注デフォルト設定' },
] as const;

// 後方互換性のために個別エクスポートも提供
export const TABLE_CONTENT_ID = TABLE_IDS.INVENTORY_CONTROL;
export const ORDER_MODE_TABLE_CONTENT_ID = TABLE_IDS.ORDER_MODE;
export const GROUP_MENU_ITEMS = GROUP_MENU.ITEMS;
export const GROUP_ACTION_TYPES = GROUP_MENU.ACTION_TYPES;
export const HEADER_COLUMN_DEFAULT_NUMBER = TABLE_LAYOUT.HEADER_COLUMN_DEFAULT_NUMBER;
export const ORDER_HEADER_COLUMN_DEFAULT_NUMBER = TABLE_LAYOUT.ORDER_HEADER_COLUMN_DEFAULT_NUMBER;
export const INVENTORY_CONTROL_TABLE_MIN_WIDTH = TABLE_LAYOUT.MIN_WIDTH;
